import React from "react";
import { useState } from "react";
import { useCallback } from "react";
import { GENERATE_REPORT } from "../../../api/apiUrls";
import axios from "axios";
import { useEffect } from "react";
import Select from "react-select";
import { packageCodes, paymentStatusOptions, stStatusOptions } from "../../../static/dropdown";
import ApsTable from "./ApsTable";
import { buildCondition } from "../../../static/hook";
import CustomSpinner from "../../../components/CustomSpinner";
import MenuIcon from "@mui/icons-material/Menu";
import { useSearchParams } from "react-router-dom";
import NotAuthorize from "../../../error/NotAuthorize";

const ApsDashboard = ({ setShowSideOverlay, user, serverURL }) => {
  const [searchParams] = useSearchParams();
  const userCode = parseInt(searchParams.get("userCode"));
  const [authState, setAuthState] = useState(false);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [dateFilterRange, setDateFilterRange] = useState([]);
  const [apsAllReport, setApsAllReport] = useState(null);
  const [apsAllLoading, setApsAllLoading] = useState(false);
  const [apsFilledReport, setApsFilledReport] = useState(null);
  const [apsFilledLoading, setApsFilledLoading] = useState(false);
  const [apsReviewedReport, setApsReviewedReport] = useState(null);
  const [apsReviewedLoading, setApsReviewedLoading] = useState(false);

  const [funnelTable, setFunnelTable] = useState(null)
  const [filterDropdown, setFilterDropdown] = useState({
    intakeOptions: [], // Example format: [{ name: 'Intake1', value: 1 }]
    locationOptions: [],
    checklistOptions: [],
    categoryOptions: [],
    apsCategory: [],
    apsFormStatus: [],
    academicStatus: [],
  });
  const [filterOptions, setFilterOptions] = useState({
    location: [], //1 s.locCode
    package: [], //2 s.packageCode
    intake: [], //3 s.intakeCode
    course: [], //4 s.coursetype
    ststatus: [], //5 s.ststatus
    category: [], //6 s.catCode
    paymentStatus: [], //7 s.PaymentStatus
    apsPayment: [], //7 v.Apspayment
    apsCategory: [], //7 v.ApsCategory
    apsFormStatus: [], //7 v.ApsCategory
    academicStatus: [], //7 v.Acadmicstatuscode
  });

  const [funnelData, setFunnelData] = useState(null)

  const fetchBaseQuery = useCallback(async (query) => {
    if (!query?.trim()) {
      console.warn("No query found to execute");
      return null;
    }
    try {
      const { data } = await axios.post(GENERATE_REPORT, { query });
      return data || null;
    } catch (error) {
      console.error(
        "Error occurred in fetchBaseQuery:",
        error?.response?.data?.message || error.message || "Unknown error"
      );
      return null;
    }
  }, []);

  const fetchFilterDropdown = useCallback(async () => {
    try {
      const queries = {
        intakeOptions:
          "SELECT IntakeCode AS 'Code', Intakename AS 'Name' FROM intakemas",
        locationOptions:
          "SELECT LocCode AS 'Code', locname AS 'Name' FROM locmas",
        checklistOptions:
          "SELECT DoctypeCode AS 'Code', DoctypeName AS 'Name' FROM DocTypeMas WHERE DoctypeCode NOT IN (11, 12, 13, 17, 26)",
        categoryOptions:
          "SELECT CatCode AS 'Code', CatName AS 'Name' FROM catmas",
        apsCategory:
          "SELECT compid AS Code, Compname AS Name  FROM commontypemas WHERE compcode = 'Aps_Category'",
        apsFormStatus:
          "SELECT compid AS Code, Compname AS Name  FROM commontypemas WHERE compcode = 'APS_Form_Status'",
        academicStatus:
          "SELECT compid AS Code, Compname AS Name  FROM commontypemas WHERE compcode = 'Academic_status'",
      };

      const fetchPromises = Object.entries(queries).map(
        async ([key, query]) => {
          const data = await fetchBaseQuery(query);
          return { key, data };
        }
      );

      const results = await Promise.all(fetchPromises);

      const updatedDropdowns = results.reduce((acc, { key, data }) => {
        if (data?.length) {
          acc[key] = data.map((item) => ({
            label: item.NAME || "Unknown",
            value: item.CODE || "N/A",
          }));
        } else {
          console.warn(`No data received for ${key}`);
        }
        return acc;
      }, {});

      if (Object.keys(updatedDropdowns).length) {
        setFilterDropdown((prev) => ({ ...prev, ...updatedDropdowns }));
      }
    } catch (error) {
      console.error("Error fetching filter dropdown options:", error.message);
    }
  }, [fetchBaseQuery]);

  const fetchApsReports = async () => {
    setApsAllLoading(true);
    try {
      const filters = [];

      const conditions = [
        buildCondition("s.intakeCode", filterOptions.intake, true),
        buildCondition("s.packageCode", filterOptions.package, true),
        buildCondition("s.PaymentStatus", filterOptions.paymentStatus),
        buildCondition("s.LocCode", filterOptions.location, true),
        buildCondition("s.ststatus", filterOptions.ststatus, true),
        buildCondition("s.coursetype", filterOptions.course),
        buildCondition("v.Apspayment", filterOptions.apsPayment),
        buildCondition("v.ApsCategory", filterOptions.apsCategory, true),
        buildCondition("v.Apsformstatus", filterOptions.apsFormStatus, true),
        buildCondition("v.Acadmicstatuscode", filterOptions.academicStatus),
      ];

      conditions.forEach((cond) => cond && filters.push(cond));

      // Handle date range
      const rangeCondition =
        dateFilterRange?.length === 2 &&
          typeof dateFilterRange[0] === "string" &&
          typeof dateFilterRange[1] === "string" &&
          dateFilterRange[0].trim() &&
          dateFilterRange[1].trim()
          ? `CAST(s.RegistrDate AS DATE) BETWEEN '${dateFilterRange[0]}' AND '${dateFilterRange[1]}'`
          : "";

      if (rangeCondition) filters.push(rangeCondition);
      const baseQuery =
        "SELECT COUNT(DISTINCT s.StdCode)  FROM StudentMas s LEFT JOIN VisaMasNew v ON s.StdCode = v.StdCode JOIN intakemas i ON i.intakeCode = s.intakeCode JOIN catmas ct ON ct.catCode = s.catCode JOIN locmas lo ON lo.locCode = s.locCode";
      const whereClause = filters.length ? `AND ${filters.join(" AND ")}` : "";
      const queries = {
        total_students: `${baseQuery} WHERE s.StdCode IS NOT NULL ${whereClause}`,
        totalApsNotApplied: `${baseQuery} WHERE ( v.ApsStatus IN ('2) YG APS/VISA FORM RECEIVED', '1)INTRO APS EMAIL & CALL DONE', '3)APS FORM FILLED BY YG', '4)APS FORM COMPLETED & CHECKLIST SENT', '5)FINAL FILE RECEIVED AND VERIFIED') OR v.ApsStatus IS NULL OR v.ApsStatus = '' ) ${whereClause}`,
        totalApsApplied: `${baseQuery} WHERE v.ApsStatus IN ('6)DOCS SENT TO APS', '7)APS CERTI. FOLLOWUP', 'SELF APPLIED') ${whereClause}`,
        not_updated: `${baseQuery} WHERE (v.ApsStatus IS NULL OR v.ApsStatus = '')  ${whereClause}`,
        aps_not_started: `${baseQuery} WHERE v.ApsStatus = '0) APS NOT STARTED DUE TO LOW PAYMENT'  ${whereClause}`,
        intro_aps_call_done: `${baseQuery} WHERE v.ApsStatus = '1)INTRO APS EMAIL & CALL DONE'  ${whereClause}`,
        form_recieved: `${baseQuery} WHERE v.ApsStatus = '2) YG APS/VISA FORM RECEIVED'  ${whereClause}`,
        form_filled: `${baseQuery} WHERE v.ApsStatus = '3)APS FORM FILLED BY YG'  ${whereClause}`,
        form_completed: `${baseQuery} WHERE v.ApsStatus = '4)APS FORM COMPLETED & CHECKLIST SENT'  ${whereClause}`,
        final_file_recieved: `${baseQuery} WHERE v.ApsStatus = '5)FINAL FILE RECEIVED AND VERIFIED'  ${whereClause}`,
        doc_sent_to_aps: `${baseQuery} WHERE v.ApsStatus = '6)DOCS SENT TO APS'  ${whereClause}`,
        aps_followup: `${baseQuery} WHERE v.ApsStatus = '7)APS CERTI. FOLLOWUP'  ${whereClause}`,
        uploaded_on_dropbox: `${baseQuery} WHERE v.ApsStatus = '8)APS RECEIVED & UPLOADED ON DROPBOX'  ${whereClause}`,
        aps_recieved_self: `${baseQuery} WHERE v.ApsStatus = 'APS RECEIVED(SELF APPLIED)'  ${whereClause}`,
        foreign_degree: `${baseQuery} WHERE v.ApsStatus = 'FOREIGN DEGREE'  ${whereClause}`,
        not_applicable: `${baseQuery} WHERE v.ApsStatus IN ('NA', 'NOT APPLICABLE')  ${whereClause}`,
        pursuing: `${baseQuery} WHERE v.ApsStatus = 'PURSUING CLASS 12'  ${whereClause}`,
        rejection: `${baseQuery} WHERE v.ApsStatus = 'REJECTION'  ${whereClause}`,
        self_applied: `${baseQuery} WHERE v.ApsStatus = 'SELF APPLIED'  ${whereClause}`,
      };

      const responseObj = {};
      for (const query in queries) {
        const result = await fetchBaseQuery(queries[query]);
        responseObj[query] = {
          count: result[0]?.Column1,
          query: queries[query],
        };
      }
      if (responseObj) {
        setApsAllReport(responseObj);
      }

    } catch (error) {
      console.error(error);
      setApsAllLoading(false);
    } finally {
      setApsAllLoading(false);
    }
  };
  const fetchApsFilledReports = async () => {
    setApsFilledLoading(true)
    try {
      const filters = [];

      const conditions = [
        buildCondition("s.intakeCode", filterOptions.intake, true),
        buildCondition("s.packageCode", filterOptions.package, true),
        buildCondition("s.PaymentStatus", filterOptions.paymentStatus),
        buildCondition("s.ststatus", filterOptions.ststatus, true),
        buildCondition("s.LocCode", filterOptions.location, true),
        buildCondition("s.coursetype", filterOptions.course),
        buildCondition("v.Apspayment", filterOptions.apsPayment),
        buildCondition("v.ApsCategory", filterOptions.apsCategory, true),
        buildCondition("v.Apsformstatus", filterOptions.apsFormStatus, true),
        buildCondition("v.Acadmicstatuscode", filterOptions.academicStatus),
      ];

      conditions.forEach((cond) => cond && filters.push(cond));

      // Handle date range
      const rangeCondition =
        dateFilterRange?.length === 2 &&
          typeof dateFilterRange[0] === "string" &&
          typeof dateFilterRange[1] === "string" &&
          dateFilterRange[0].trim() &&
          dateFilterRange[1].trim()
          ? `CAST(s.RegistrDate AS DATE) BETWEEN '${dateFilterRange[0]}' AND '${dateFilterRange[1]}'`
          : "";

      if (rangeCondition) filters.push(rangeCondition);
      const whereClause = filters.length ? `AND ${filters.join(" AND ")}` : "";
      const query = `SELECT v.Apsfilledby, COUNT(DISTINCT s.StdCode) FROM StudentMas s LEFT JOIN VisaMasNew v ON s.StdCode = v.StdCode WHERE s.StdCode IS NOT NULL ${whereClause} GROUP BY v.Apsfilledby`;

      const result = await fetchBaseQuery(query);
      setApsFilledReport(result)
    } catch (error) {
      console.error(error);
      setApsFilledLoading(false)
    } finally {
      setApsFilledLoading(false)
    }

  };
  const fetchApsReviewedReports = async () => {
    setApsReviewedLoading(true)
    try {
      const filters = [];

      const conditions = [
        buildCondition("s.intakeCode", filterOptions.intake, true),
        buildCondition("s.packageCode", filterOptions.package, true),
        buildCondition("s.PaymentStatus", filterOptions.paymentStatus),
        buildCondition("s.LocCode", filterOptions.location, true),
        buildCondition("s.coursetype", filterOptions.course),
        buildCondition("v.Apspayment", filterOptions.apsPayment),
        buildCondition("v.ApsCategory", filterOptions.apsCategory, true),
        buildCondition("v.Apsformstatus", filterOptions.apsFormStatus, true),
        buildCondition("v.Acadmicstatuscode", filterOptions.academicStatus),
      ];

      conditions.forEach((cond) => cond && filters.push(cond));

      // Handle date range
      const rangeCondition =
        dateFilterRange?.length === 2 &&
          typeof dateFilterRange[0] === "string" &&
          typeof dateFilterRange[1] === "string" &&
          dateFilterRange[0].trim() &&
          dateFilterRange[1].trim()
          ? `CAST(s.RegistrDate AS DATE) BETWEEN '${dateFilterRange[0]}' AND '${dateFilterRange[1]}'`
          : "";

      if (rangeCondition) filters.push(rangeCondition);
      const whereClause = filters.length ? `AND ${filters.join(" AND ")}` : "";
      const query = `SELECT v.ApsReviewedby, COUNT(DISTINCT s.StdCode)  FROM StudentMas s LEFT JOIN VisaMasNew v ON s.StdCode = v.StdCode WHERE s.StdCode IS NOT NULL ${whereClause} GROUP BY v.ApsReviewedby`;

      const result = await fetchBaseQuery(query);
      console.log("first", result)
      setApsReviewedReport(result)
    } catch (error) {
      console.error(error);
      setApsReviewedLoading(false)
    } finally {
      setApsReviewedLoading(false)
    }

  };

  const handleChange = (index, value) => {
    const updatedRange = dateFilterRange;
    updatedRange[index] = value; // value will be in 'YYYY-MM-DD' format
    setDateFilterRange(updatedRange);
  };

  const handleFilterChange = () => {
    fetchApsReports();
    fetchApsFilledReports();
    fetchApsReviewedReports();
  };

  const checkAuthentication = async () => {
    try {
      if (userCode === 0) {
        setAuthState(true);
        return true;
      }

      const checkAdmin = await fetchBaseQuery(
        `SELECT * FROM usermas WHERE UserCode = ${userCode} AND deptcode IN (15, 17, 16, 12, 4, 6)`
      );

      if (Array.isArray(checkAdmin) && checkAdmin.length > 0) {
        setAuthState(true);
        return true;
      }

      setAuthState(false);
      return false;
    } catch (error) {
      console.error("Error checking authentication:", error);
      setAuthState(false);
      return false;
    }
  };
  useEffect(() => {
    checkAuthentication();
  }, [userCode, authState]);


  const fetchFunnelValuesWithData = async () => {
    const getValuesNow = await axios.post(serverURL + "/automations/getAPSFunnelStyleReport")
    if (getValuesNow.status === 200) {
      setFunnelData(getValuesNow.data)
      console.log(getValuesNow.data)
    } else {
      console.log(getValuesNow.data)
    }
  }

  const showTableData = async (type) => {
    setFunnelTable(type)
  }

  useEffect(() => {
    fetchFunnelValuesWithData();

    fetchFilterDropdown();
    fetchApsReports();
    fetchApsFilledReports();
    fetchApsReviewedReports();

  }, []);

  return authState ? (
    <div className="transback h-100 overflow-auto p-3 d-flex flex-column">
      <button
        className="btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none align-items-center gap-2"
        onClick={() => setShowSideOverlay(true)}
      >
        <MenuIcon />
      </button>
      <div className="headerUserDetails py-1 mb-3 d-flex justify-content-between">
        <span>APS Dashboard</span>
        <div
          className="d-flex gap-2 align-items-center"
          title={`Name: ${user?.name} | Email: ${user?.email}`}
        >
          <i className="fa fa-user"></i>
          <span>{user?.name}</span>
        </div>
      </div>

      <div className="w-100 h-100 overflow-auto ">
        {spinnerLoading ? (
          <div className="w-100 h-100 d-flex align-items-center justify-content-center">
            <CustomSpinner size={1} />
          </div>
        ) : (
          <>
            <div>
              <div className="header py-3 border border-light px-2 rounded bg-light">
                <h5>Filter</h5>
                <div className="row g-2 g-lg-3 mb-3">
                  <div className="col-md-2">
                    <div className="form-group">
                      <Select
                        id="intake-select"
                        options={filterDropdown.intakeOptions}
                        isMulti
                        isClearable
                        placeholder="Select Intake"
                        onChange={(selectedOptions) => {
                          setFilterOptions((prev) => ({
                            ...prev,
                            intake: selectedOptions
                              ? selectedOptions.map((opt) =>
                                parseInt(opt.value)
                              )
                              : [],
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <Select
                        id="package-select"
                        options={filterDropdown.locationOptions}
                        isMulti
                        isClearable
                        placeholder="Select Branch"
                        onChange={(selectedOptions) => {
                          setFilterOptions((prev) => ({
                            ...prev,
                            location: selectedOptions
                              ? selectedOptions.map((opt) =>
                                parseInt(opt.value)
                              )
                              : [],
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <Select
                        id="ststatus-select"
                        options={stStatusOptions}
                        isMulti
                        isClearable
                        placeholder="Select Student Status"
                        onChange={(selectedOptions) => {
                          setFilterOptions((prev) => ({
                            ...prev,
                            ststatus: selectedOptions
                              ? selectedOptions.map((opt) =>
                                parseInt(opt.value)
                              )
                              : [],
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <Select
                        id="category-select"
                        options={filterDropdown.categoryOptions}
                        isMulti
                        isClearable
                        placeholder="Select Student Category"
                        onChange={(selectedOptions) => {
                          setFilterOptions((prev) => ({
                            ...prev,
                            category: selectedOptions
                              ? selectedOptions.map((opt) =>
                                parseInt(opt.value)
                              )
                              : [],
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <Select
                        id="package-select"
                        options={packageCodes}
                        isMulti
                        isClearable
                        placeholder="Select Package"
                        onChange={(selectedOptions) => {
                          setFilterOptions((prev) => ({
                            ...prev,
                            package: selectedOptions
                              ? selectedOptions.map((opt) =>
                                parseInt(opt.value)
                              )
                              : [],
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <Select
                        id="payment-select"
                        options={paymentStatusOptions}
                        isMulti
                        isClearable
                        placeholder="Select Payment Status"
                        onChange={(selectedOptions) => {
                          setFilterOptions((prev) => ({
                            ...prev,
                            paymentStatus: selectedOptions
                              ? selectedOptions.map((opt) =>
                                opt.value
                              )
                              : [],
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <Select
                        id="apsPayment-select"
                        options={[
                          { label: 'Done', value: 'Done' },
                          { label: 'Not done', value: 'Not done' },
                        ]}
                        isMulti
                        isClearable
                        placeholder="Select APS Payment Status"
                        onChange={(selectedOptions) => {
                          setFilterOptions((prev) => ({
                            ...prev,
                            apsPayment: selectedOptions
                              ? selectedOptions.map((opt) =>
                                opt.value
                              )
                              : [],
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <Select
                        id="course-select"
                        options={[
                          { label: "Master's", value: "M" },
                          { label: "Bachelor's", value: "B" },
                        ]}
                        isMulti
                        isClearable
                        placeholder="Select Course"
                        onChange={(selectedOptions) => {
                          setFilterOptions((prev) => ({
                            ...prev,
                            course: selectedOptions
                              ? selectedOptions.map((opt) => opt.value)
                              : [],
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <Select
                        id="apsCat-select"
                        options={filterDropdown.apsCategory}
                        isMulti
                        isClearable
                        placeholder="Select APS Category"
                        onChange={(selectedOptions) => {
                          setFilterOptions((prev) => ({
                            ...prev,
                            apsCategory: selectedOptions
                              ? selectedOptions.map((opt) => parseInt(opt.value))
                              : [],
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <Select
                        id="apsCat-select"
                        options={filterDropdown.apsFormStatus}
                        isMulti
                        isClearable
                        placeholder="Select APS Form Status"
                        onChange={(selectedOptions) => {
                          setFilterOptions((prev) => ({
                            ...prev,
                            apsFormStatus: selectedOptions
                              ? selectedOptions.map((opt) => parseInt(opt.value))
                              : [],
                          }));
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <Select
                        id="academic-select"
                        options={filterDropdown.academicStatus}
                        isMulti
                        isClearable
                        placeholder="Select Academic Status"
                        onChange={(selectedOptions) => {
                          setFilterOptions((prev) => ({
                            ...prev,
                            academicStatus: selectedOptions
                              ? selectedOptions.map((opt) => parseInt(opt.value))
                              : [],
                          }));
                        }}
                      />
                    </div>
                  </div>
                  {/* <div className="col-md-1 text-end">
                    <label htmlFor="">Select Range</label>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group d-flex">
                      <input
                        type="date"
                        className="form-control"
                        // value={dateFilterRange[0] || ""}
                        onChange={(e) => handleChange(0, e.target.value)}
                      />
                      <input
                        type="date"
                        className="form-control"
                        // value={dateFilterRange[1] || ""}
                        onChange={(e) => handleChange(1, e.target.value)}
                      />
                    </div>
                  </div> */}
                  <div className="form-group col-md-2">
                    <button
                      type="button"
                      className="btn btn-warning btn-sm"
                      onClick={handleFilterChange}
                    >
                      Apply Filter
                    </button>
                  </div>
                </div>
              </div>

              {/* Funnel Diagram Start */}
              <div className="d-flex justify-content-start w-100 gap-3 flex-wrap">
                <div className="d-flex justify-content-around flex-wrap gap-5">


                  <div className="mainFunnelFrame" style={{ maxWidth: "650px", marginRight: "120px" }}>
                    <div className="frame" onClick={(e) => { setFunnelTable(null) }}>
                      <span className="textVersions">
                        <span>Total Students</span>
                        <span>{funnelData?.totalActive}</span>
                      </span>
                      <div className="dataResult">Pending</div>
                    </div>
                    <div className="frame" onClick={(e) => { showTableData("") }}>
                      <span className="textVersions">
                        <span>Cases For APS</span>
                        <span>
                          {funnelData?.apsNotApplicablePending}
                        </span>
                      </span>
                      <div className="dataResult flex-column">
                        <span style={{fontSize:"12px"}}>NA & FD</span>
                        {funnelData?.apsNotApplicable}
                        </div>
                    </div>
                    <div className="frame" onClick={(e) => { showTableData("") }}>
                      <span className="textVersions">
                        <span>Document received</span>
                        <span>
                          {
                            funnelData?.apsRecieved1 +
                            funnelData?.apsRecieved2 +
                            funnelData?.apsRejected +
                            funnelData?.applied +
                            funnelData?.notStarted3 +
                            funnelData?.notApplied1 +
                            funnelData?.notApplied2 +
                            funnelData?.notApplied3
                          }
                        </span>
                      </span>
                      <div className="dataResult">{funnelData?.totalActive - (funnelData?.apsRecieved1 +
                        funnelData?.apsRecieved2 +
                        funnelData?.apsRejected +
                        funnelData?.applied +
                        funnelData?.notStarted3 +
                        funnelData?.notApplied1 +
                        funnelData?.notApplied2 +
                        funnelData?.notApplied3)}</div>
                    </div>
                    <div className="frame" onClick={(e) => { showTableData("") }}>
                      <span className="textVersions">
                        <span>APS Applied</span>
                        <span>{funnelData?.apsRecieved1 + funnelData?.apsRecieved2 + funnelData?.apsRejected + funnelData?.applied}</span>
                      </span>
                      <div className="dataResult">{
                        (funnelData?.apsRecieved1 +
                          funnelData?.apsRecieved2 +
                          funnelData?.apsRejected +
                          funnelData?.applied +
                          funnelData?.notStarted3 +
                          funnelData?.notApplied1 +
                          funnelData?.notApplied2 +
                          funnelData?.notApplied3
                        )
                        -
                        (funnelData?.apsRecieved1 + funnelData?.apsRecieved2 + funnelData?.apsRejected + funnelData?.applied)}</div>
                    </div>
                    <div className="frame" onClick={(e) => { showTableData("") }}>
                      <span className="textVersions">
                        <span>
                          Received
                        </span>
                        <span>{funnelData?.apsRecieved1 + funnelData?.apsRecieved2}</span>
                      </span>
                      <div className="dataResult">
                        {(funnelData?.apsRecieved1 + funnelData?.apsRecieved2 + funnelData?.apsRejected + funnelData?.applied) - (funnelData?.apsRecieved1 + funnelData?.apsRecieved2)}
                      </div>
                    </div>
                  </div>

                </div>
                <div className="d-flex justify-content-around flex-wrap gap-5">
                  <div className="mainFunnelFrameCarded" style={{ maxWidth: "500px" }}>
                    <div className="frame" onClick={(e) => { setFunnelTable(null) }}>
                      <span className="textVersions">
                        <span>Total Students</span>
                        <span>{funnelData?.totalActive}</span>
                      </span>
                    </div>
                    <div className="frame" onClick={(e) => { showTableData("Not Started") }}>
                      <span className="textVersions">
                        <span>Not Started</span>
                        <span>{funnelData?.notStarted}</span>
                      </span>
                    </div>
                    <div className="frame" onClick={(e) => { showTableData("Not Applied") }}>
                      <span className="textVersions">
                        <span>
                          Not Applied
                        </span>
                        <span>{funnelData?.notApplied}</span>
                      </span>
                    </div>
                    <div className="frame" onClick={(e) => { showTableData("Applied") }}>
                      <span className="textVersions">
                        <span>
                          Applied
                        </span>
                        <span>{funnelData?.applied}</span>
                      </span>
                    </div>
                    <div className="frame">
                      <span className="textVersions">
                        <span>
                          APS Outcomes
                        </span>
                        <div className="internalFraming">

                          <button className="text-success" onClick={(e) => { showTableData("APS Recieved") }}>
                            <span>Recieved:</span>
                            {funnelData?.apsRecieved}
                          </button>
                          <button className="text-danger" onClick={(e) => { showTableData("APS Rejected") }}>
                            <span>Rejected:</span>
                            {funnelData?.apsRejected}
                          </button>
                          <button className="text-dark" onClick={(e) => { showTableData("Not Applicable") }}>
                            <span>Not Applicable:</span>
                            {funnelData?.apsNotApplicable}
                          </button>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div className={"w-100 overflow-auto"} style={{ maxWidth: "min-content" }}>

                    <table className="table table-bordered table-hover m-0" style={{ maxWidth: "min-content", fontSize: "12px" }}>
                      <tbody>
                        <tr valign="middle">
                          <th style={funnelTable === "Not Started" ? { background: "#ff5c5c", color: "white" } : {}} className="text-nowrap">NOT STARTED DUE TO LOW PAYMENT</th>
                          <td style={funnelTable === "Not Started" ? { background: "#ff5c5c", color: "white" } : {}} align="middle">{funnelData?.notStarted1}</td>
                        </tr>
                        <tr valign="middle">
                          <th style={funnelTable === "Not Started" ? { background: "#ff5c5c", color: "white" } : {}} className="text-nowrap">INTRO APS EMAIL & CALL DONE</th>
                          <td style={funnelTable === "Not Started" ? { background: "#ff5c5c", color: "white" } : {}} align="middle">{funnelData?.notStarted2}</td>
                        </tr>
                        <tr valign="middle">
                          <th style={funnelTable === "Not Started" ? { background: "#ff5c5c", color: "white" } : {}} className="text-nowrap">YG APS/VISA FORM RECEIVED</th>
                          <td style={funnelTable === "Not Started" ? { background: "#ff5c5c", color: "white" } : {}} align="middle">{funnelData?.notStarted3}</td>
                        </tr>
                        <tr valign="middle">
                          <th style={funnelTable === "Not Started" ? { background: "#ff5c5c", color: "white" } : {}} className="text-nowrap">PURSUING CLASS 12</th>
                          <td style={funnelTable === "Not Started" ? { background: "#ff5c5c", color: "white" } : {}} align="middle">{funnelData?.notStarted4}</td>
                        </tr>
                      </tbody>
                      <tbody >
                        {/* <tr valign="middle">
                        <th>Total</th>
                        <th align="middle" className="text-center">{funnelData.notStarted}</th>
                      </tr> */}



                        <tr>
                          <th style={funnelTable === "Not Applied" ? { background: "#741a3f", color: "white" } : {}} className="text-nowrap">APS FORM FILLED BY YG</th>
                          <td style={funnelTable === "Not Applied" ? { background: "#741a3f", color: "white" } : {}} align="middle">{funnelData?.notApplied1}</td>
                        </tr>
                        <tr>
                          <th style={funnelTable === "Not Applied" ? { background: "#741a3f", color: "white" } : {}} className="text-nowrap">APS FORM COMPLETED & CHECKLIST SENT</th>
                          <td style={funnelTable === "Not Applied" ? { background: "#741a3f", color: "white" } : {}} align="middle">{funnelData?.notApplied2}</td>
                        </tr>
                        <tr>
                          <th style={funnelTable === "Not Applied" ? { background: "#741a3f", color: "white" } : {}} className="text-nowrap">FINAL FILE RECEIVED AND VERIFIED</th>
                          <td style={funnelTable === "Not Applied" ? { background: "#741a3f", color: "white" } : {}} align="middle">{funnelData?.notApplied3}</td>
                        </tr>
                        {/* <tr valign="middle">
                        <th>Total</th>
                        <th align="middle" className="text-center">{funnelData.notApplied}</th>
                      </tr> */}
                      </tbody>
                      <tbody>

                        <tr>
                          <th style={funnelTable === "Applied" ? { background: "#004caf", color: "white" } : {}} className="text-nowrap">SELF APPLIED</th>
                          <td style={funnelTable === "Applied" ? { background: "#004caf", color: "white" } : {}} align="middle">{funnelData?.applied1}</td>
                        </tr>
                        <tr>
                          <th style={funnelTable === "Applied" ? { background: "#004caf", color: "white" } : {}} className="text-nowrap">DOCS SENT TO APS</th>
                          <td style={funnelTable === "Applied" ? { background: "#004caf", color: "white" } : {}} align="middle">{funnelData?.applied2}</td>
                        </tr>
                        <tr>
                          <th style={funnelTable === "Applied" ? { background: "#004caf", color: "white" } : {}} className="text-nowrap">APS CERTI. FOLLOWUP</th>
                          <td style={funnelTable === "Applied" ? { background: "#004caf", color: "white" } : {}} align="middle">{funnelData?.applied3}</td>
                        </tr>
                        {/* <tr valign="middle">
                        <th>Total</th>
                        <th align="middle" className="text-center">{funnelData.applied}</th>
                      </tr> */}
                      </tbody>
                      <tbody>

                        <tr>
                          <th style={funnelTable === "APS Recieved" ? { background: "green", color: "white" } : {}} className="text-nowrap">RECEIVED & UPLOADED ON DROPBOX</th>
                          <td style={funnelTable === "APS Recieved" ? { background: "green", color: "white" } : {}}>{funnelData?.apsRecieved1}</td>
                        </tr>
                        <tr>
                          <th style={funnelTable === "APS Recieved" ? { background: "green", color: "white" } : {}} className="text-nowrap">RECEIVED(SELF APPLIED)</th>
                          <td style={funnelTable === "APS Recieved" ? { background: "green", color: "white" } : {}}>{funnelData?.apsRecieved2}</td>
                        </tr>
                        {/* <tr>
                        <th>Total</th>
                        <th>{funnelData?.apsRecieved}</th>
                      </tr> */}

                      </tbody>
                      <tbody>
                        <tr>
                          <th style={funnelTable === "APS Rejected" ? { background: "#dc3545", color: "white" } : {}} className="text-nowrap">REJECTION</th>
                          <td style={funnelTable === "APS Rejected" ? { background: "#dc3545", color: "white" } : {}}>{funnelData?.apsRejected}</td>
                        </tr>
                        {/* <tr>
                        <th>Total</th>
                        <th>{funnelData?.apsRejected}</th>
                      </tr> */}
                      </tbody>
                      <tbody >
                        <tr>
                          <th style={funnelTable === "Not Applicable" ? { background: "silver" } : {}} className="text-nowrap">NA</th>
                          <td style={funnelTable === "Not Applicable" ? { background: "silver" } : {}}>{funnelData?.apsNotApplicable1}</td>
                        </tr>
                        <tr>
                          <th style={funnelTable === "Not Applicable" ? { background: "silver" } : {}} className="text-nowrap">FOREIGN DEGREE</th>
                          <td style={funnelTable === "Not Applicable" ? { background: "silver" } : {}}>{funnelData?.apsNotApplicable2}</td>
                        </tr>
                        <tr>
                          <th style={funnelTable === "Not Applicable" ? { background: "silver" } : {}} className="text-nowrap">NOT APPLICABLE</th>
                          <td style={funnelTable === "Not Applicable" ? { background: "silver" } : {}}>{funnelData?.apsNotApplicable3}</td>
                        </tr>
                        {/* <tr>
                        <th>Total</th>
                        <th>{funnelData?.apsNotApplicable}</th>
                      </tr> */}

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* Funnel Diagram End */}

              <div className="mt-5">
                <ApsTable
                  apsAllReport={apsAllReport}
                  apsAllLoading={apsAllLoading}
                  apsFilledReport={apsFilledReport}
                  apsFilledLoading={apsFilledLoading}
                  apsReviewedReport={apsReviewedReport}
                  apsReviewedLoading={apsReviewedLoading}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  ) : <NotAuthorize />;
};

export default ApsDashboard;
